import { IUiConfiguration } from '../xlr-config';

export const EMERALD_SS_CONFIG: IUiConfiguration = {
  showBuID: false,
  showScanMessage: true,
  productName: 'Emerald',
  browserTitle: 'Emerald',
  showPasswordLabel: true,
  behaviorLookupRequest: true,
  separateApprovalRequest: true,
  showPhoneNumberOnCustomerSearch: false,
  showStatusOnCustomerSearch: true,
  recallInterventionsSupported: false,
  fullCartResponse: true,
  callPriceQueryOnPluItem: false,
  showQuantityOnItemVoidedLine: false,
  preTenderFullEquality: false,
  groupedCouponSummary: false,
  voidAllCouponsOnVoidTransaction: true,
  dynamicTender: false,
  finishTransactionOnlyWhenBalanceDueZero: false,
  callGetEffectiveTaxRates: true,
  mergeBrmInputs: false,
  validateLettersOnlyOnSearchForm: true,
  manualTareAlwaysEnabled: true,
  allowModifyTareForWeightedItems: true,
  showZeroUnusedCoupons: false,
  showZeroIssuedCoupons: false,
  registrationAuthenticationSupported: false,
  serverSideExitTrainingMode: false,
  requiresPreTenderInitAndCancel: false,
  resendPreTenderOnce: true,
  requiresDecodePrescription: true,
  requiresTPSCallsForEft: true,
  requiresTPSCallsForEwic: false,
  requiresGetFinalRxBalance: true,
  requiresCancelPreTenderFromCart: true,
  validateAlternateId: false,
  requiresAlternateTenderNotification: true,
  balancesWithEwicService: true,
  showPreDefinedOptionsForTareWeightItem: false,
  hidePriceInPriceEntryDialog: false,
  allowModifyingTareForSingleGroupItem: true,
  sortBySequence: true,
  runClientValidationWhenOverridingToHigherPrice: true,
  requiresUpdateTouchPoint: true,
  callBalanceAfterTenderAdd: true,
  showTareLinkedItemOnEJ: true,
  interventionsSuspendOnCancel: true,
  checkEndorsement: true,
  recallUpdateCartStatus: true,
  usePackIdentifier: true,
  voidItemWhenRejectIntervention: false,
  showCustomerSearchTotals: true,
  voidRejectInterventionsPreSolve: true,
  requiresGetTenderFromCart: true,
  priceCheckDecode: true,
  callTlogInvalidPassword: true,
  separatePaymentOptionsObjectInTender: true,
  warmupPostLogin: true,
  useTrainingModeAPIs: false,
  allowPartialPaymentFromKeypad: false,
  useRefundToCalculateChange: true,
  callTlogTerminal: true,
  shouldPromptPhoneNumberWhenSwipeAhead: true,
  auditUserHeader: true,
  eftSignatureVerificationDialog: false,
  shouldDisplayTenderNotAllowedForChangeErrorMessage: false,
  notifyShift: false,
  shouldCallCardIdentificationNotExpected: false,
  transactionLookupSupported: false,
  supportMsvRewards: true,
  alertWhenCustomerNotFound: true,
  getCustomerFromCartResponse: false,
  showEwicQuantityErrorMessage: true,
  disableLoyaltySearchOnTenderMode: true,
};
